import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfiguratorModuleComponent } from './configurator-module.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddConfiguratorModuleComponent } from './add-configurator-module/add-configurator-module.component';
import { EditConfiguratorModuleComponent } from './edit-configurator-module/edit-configurator-module.component';

@NgModule({
  declarations: [ConfiguratorModuleComponent, AddConfiguratorModuleComponent, EditConfiguratorModuleComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [ConfiguratorModuleComponent],
})
export class ConfiguratorModuleModule {}
